import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Link } from 'expo-router';
import { LabelText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <View style={styles.container}>
      <LabelText style={styles.text} bold>
        Loyalty
      </LabelText>

      <Link href="/" asChild dismissTo>
        <TouchableOpacity style={styles.cta}>
          <LabelText sizeMatch={['12']} style={styles.ctaText}>
            Go back
          </LabelText>
        </TouchableOpacity>
      </Link>
    </View>
  );
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.BLUEBERRY,
    gap: theme.spacing['10'],
    padding: theme.spacing['10'],
  },
  text: {
    color: theme.colors.WHITE,
  },
  cta: {
    backgroundColor: theme.colors.WHITE,
    borderRadius: theme.radius.large,
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['3'],
  },
  ctaText: {
    color: theme.colors.KALE,
  },
});
